<template>
  <ul class="no-bullet-list">
    <li v-for="contact in value" :key="contact" class="p-2">
      {{contact}}
    </li>
  </ul>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
  props: {
    model: {
      type: Object,
    },
    schema: {
      type: Object,
    },
  },
};
</script>
